import React from "react";

const ContentTitle = ({children}) => {
  return (
    <h2 className="display-6 text-eerie-black fw-600 mb-4">
     {children}
    </h2>
  );
};

export default ContentTitle;
